import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=2ae9d35e&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae9d35e')) {
      api.createRecord('2ae9d35e', component.options)
    } else {
      api.reload('2ae9d35e', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=2ae9d35e&", function () {
      api.rerender('2ae9d35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rXymlfBWwVlO/JS/comp/costHelpSpa.vue"
export default component.exports